module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-create-vehicle-slot"
  }, [_c('modal-reveal', {
    ref: "createVehicleSlotModal",
    attrs: {
      "sizing": "small"
    }
  }, [_c('button', {
    staticClass: "button small",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Add to Parking Lot")]), _c('h2', [_vm._v("Add V" + _vm._s(_vm.item.id) + " to a parking")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Vehicle Slot name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.name),
      expression: "body.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "name", $event.target.value)
      }
    }
  })]), _c('BookingModeSelect', {
    model: {
      value: (_vm.body.booking_mode),
      callback: function($$v) {
        _vm.$set(_vm.body, "booking_mode", $$v)
      },
      expression: "body.booking_mode"
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('selectize-grouped-parking-assets', {
    on: {
      "parkingSlotSelected": _vm.setParkingSlot
    }
  })], 1)]), _c('div', {
    staticClass: "row column"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.body.parking_slot_id || !_vm.body.booking_mode
    },
    on: {
      "click": _vm.createVehicleSlot
    }
  }, [_vm._v("Create")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-da6a068a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/asset-management/CreateVehicleSlot.vue
// module id = 2716
// module chunks = 1